import login from '../../views/Login/login'
export default [
  /* -------------- 登录 -------------- */
  {
    path: '/login',
    name: 'Login',
    component: login,
    meta: {
      persistent: true, // 持久tab，不可关闭，tab在最左侧
      showFooter: false, // 显示系统footer
      singlePage: true, // 不在Main中显示
      hideInMenu: true, // 在侧边导航中隐藏
      hideInBread: true, // 在侧边导航中隐藏
      noLoginRequired: true, // 无需登录即可进入
      access: [], // 页面权限数组
    }
  },
]
